/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box, Container, Grid, Typography, Card, CardHeader,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ReplaceSensor from '../components/replace-sensor/replaceSensor';
import AddDeviceManually from '../components/add-sensor-manually/addSensorManually';
import ScanSensor from '../components/scan-sensors/scanSensors';
import AddVstDevice from '../components/add-vst-device/addVstDevice';
import RemoveVstDevice from '../components/remove-vst-device/removeVstDevice';
import RemoveSensor from '../components/remove-sensor/removeSensor';
import SensorCredentials from '../components/verify-sensor-credentials/verifySensorCredentials';
import DeleteVideos from '../components/delete-videos/deleteVideos';
import DownloadVideos from '../components/download-video/downloadVideo';

export default function DeviceManagement() {
  const { adaptorType } = window;
  return (
    <>
      <Helmet>
        <title> Device management </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Sensor management
        </Typography>
        <Grid container spacing={3}>
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Scan sensors" subheader="Scan for sensors" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <ScanSensor />
                </Box>
              </Card>
            </Grid>
          )}
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Remove sensor" subheader={`Remove sensor from ${adaptorType}`} />
                <Box sx={{ p: 3, pb: 1 }}>
                  <RemoveSensor />
                </Box>
              </Card>
            </Grid>
          )}
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Sensor credentials" subheader="Verify credentials of a sensor" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <SensorCredentials />
                </Box>
              </Card>
            </Grid>
          )}
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Replace sensor" subheader="Replace an inactive sensor" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <ReplaceSensor />
                </Box>
              </Card>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader
                title={`Remove ${adaptorType} device`}
                subheader={`Remove endpoint for ${adaptorType} device`}
              />
              <Box sx={{ p: 3, pb: 1 }}>
                <RemoveVstDevice />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader title={`Add ${adaptorType} device`} subheader={`Add endpoint for ${adaptorType} device`} />
              <Box sx={{ p: 3, pb: 1 }}>
                <AddVstDevice />
              </Box>
            </Card>
          </Grid>
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Delete videos" subheader="Deleted recorded video files" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <DeleteVideos />
                </Box>
              </Card>
            </Grid>
          )}
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Download videos" subheader="Download recorded videos" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <DownloadVideos />
                </Box>
              </Card>
            </Grid>
          )}
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardHeader title="Add device manually" subheader="Add RTSP or IP devices" />
                <Box sx={{ p: 3, pb: 1 }}>
                  <AddDeviceManually />
                </Box>
              </Card>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
